import { useCallback, useState } from 'react';

/**
 * Opaque cover while a saved scroll offset is applied. Reset during render
 * when the tab/doc key changes so the first paint never flashes the
 * top-of-page skeleton before the snap.
 *
 * If this key opened with no offset, mark ready immediately — otherwise a
 * user scroll writes a save and the veil would appear with nobody to
 * release it.
 */
export function useDocRestoreCover(restoreKey, hasSavedScroll) {
  // ready starts true when this key has no offset — a later user scroll
  // writes a save and must not turn the veil on (nothing left to restore).
  const [cover, setCover] = useState({
    key: restoreKey,
    ready: !hasSavedScroll,
  });
  if (cover.key !== restoreKey) {
    setCover({ key: restoreKey, ready: !hasSavedScroll });
  }

  const holdCover = Boolean(hasSavedScroll && !cover.ready);

  const releaseCover = useCallback(() => {
    setCover((prev) => (
      prev.key === restoreKey && prev.ready
        ? prev
        : { key: restoreKey, ready: true }
    ));
  }, [restoreKey]);

  return { holdCover, releaseCover };
}

export default useDocRestoreCover;
